export default {"src":"https://cdn.tanzhi.cn/_next/static/media/clan.9198e1d2.svg","height":51,"width":52,"blurWidth":0,"blurHeight":0};